import { render, staticRenderFns } from "./CCloneItem.vue?vue&type=template&id=0067c4db&lang=pug"
import script from "./CCloneItem.vue?vue&type=script&lang=js"
export * from "./CCloneItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports